import { Badge, Box, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ActiveButtonBadge = styled(Badge)(({ theme, color }) => ({
    "& .MuiBadge-badge": {
        position: 'relative',
        backgroundColor: color,
        color: color,
        width: "10px",
        height: "10px",
        minWidth: "10px",
        borderRadius: "50%",
        transform: 'none'
    },
}));

export default function BatteryOverviewIndicator({name, isOn}) {
    const { t } = useTranslation(['common', 'digital_twin']);
    return (
        <Box sx={{width: '165px', backgroundColor: isOn ? '#EEF4DB' : '#F9F9F9', py: 1.5, px: 2.5, borderRadius: '8px'}}>
            <Typography variant="fw400s14lh24c686868">{name}</Typography>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
                <ActiveButtonBadge
                    color={isOn ? '#09B820' : '#8F8F8F'}
                    variant="dot"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    sx={{marginRight: '8px'}}
                ></ActiveButtonBadge>
                <Typography variant="fw400s16lh28c2E2E2E">{isOn ? t("common:on") : t("common:off")}</Typography>
            </Box>
        </Box>
    )
}
